import apiClient from '../axios';

const driverService = {
  async getAllDrivers() {
    try {
      const response = await apiClient.get('admin/drivers');
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch drivers',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch drivers',
        errors: error.response?.data?.errors
      };
    }
  },

  async getDriverById(id) {
    try {
      const response = await apiClient.get(`admin/drivers/${id}`);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch driver',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch driver',
        errors: error.response?.data?.errors
      };
    }
  },

  async updateDriver(id, payload) {
    try {
      const response = await apiClient.put(`admin/drivers/${id}`, payload);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to update driver',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update driver',
        errors: error.response?.data?.errors
      };
    }
  },

  async deleteDriver(id) {
    try {
      const response = await apiClient.delete(`admin/drivers/${id}`);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to delete driver',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete driver',
        errors: error.response?.data?.errors
      };
    }
  },

  async updateProfileImage(id, file) {
    try {
      const formData = new FormData();
      formData.append('profile_image', file);
      const response = await apiClient.post(`admin/drivers/${id}/profile-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, image_url: response.data.image_url };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to update profile image',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update profile image',
        errors: error.response?.data?.errors
      };
    }
  },

  async addDriver(payload) {
    try {
      let config = {};
      if (payload instanceof FormData) {
        config.headers = { 'Content-Type': 'multipart/form-data' };
      }
      const response = await apiClient.post('delivery/register', payload, config);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to add driver',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to add driver',
        errors: error.response?.data?.errors
      };
    }
  },
};

export default driverService; 